export default __webpack_public_path__ + "static/media/Me.f7c377a2.jpg";